<template>
  <QuestionPage :title="questionAnswerData.question">
    <QuestionAnswer
      :title="questionAnswerData.answers.A"
      class='lt-fyf-answer-holiday-basic'
      :onSelect="chooseBasic"
    />

    <QuestionAnswer
      :title="questionAnswerData.answers.B"
      class='lt-fyf-answer-holiday-medium'
      :onSelect="chooseMedium"
    />

    <QuestionAnswer
      :title="questionAnswerData.answers.C"
      class='lt-fyf-answer-holiday-top'
      :onSelect="chooseTop"
    />
  </QuestionPage>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'getQuestionAnswerData'
    ]),
    questionAnswerData() {
      return this.getQuestionAnswerData('holiday')
    }
  },
  methods: {
    ...mapMutations([
      'selectHolidayStatus',
    ]),
    ...mapActions([
      'goToItem',
    ]),
    chooseBasic: function () {
      this.selectHolidayStatus(1);
      this.goToItem('holiday');
    },
    chooseMedium: function () {
      this.selectHolidayStatus(2);
      this.goToItem('holiday');
    },
    chooseTop: function () {
      this.selectHolidayStatus(3);
      this.goToItem('holiday');
    }
  },
};
</script>

<style lang='scss'>
.lt-fyf-answer-holiday-basic {
  background-image: url('../../assets/questions/holiday-minimum.jpg');
}
.lt-fyf-answer-holiday-medium {
  background-image: url('../../assets/questions/holiday-moderate.jpg');
}
.lt-fyf-answer-holiday-top {
  background-image: url('../../assets/questions/holiday-comfortable.jpg');
}
</style>